export const params = {
  'populate[avatar][populate][fields][0]': 'url',
  'populate[avatar][populate][formats][populate][thumbnail][populate][fields][1]': 'url',
  'populate[company][populate][fields][0]': 'company_nome',
  'populate[groups][populate][fields][0]': 'name',
  'populate[groups][populate][fields][1]': 'sigla',
  'populate[user_profile][populate][fields][0]': 'name',
  'populate[user_profile][populate][permissions_users][populate][fields][1]': 'title',
  'populate[company_setors][populate][fields][0]': 'title',
  'populate[so_area_atuacaos][populate][fields][0]': 'title',
};
